import { getButton } from './Button';

function closeConfirmation(context, is_yes) {
  let temp = context.state.confirmation_dialog;
  temp.show = false;
  context.setState({ confirmation_dialog : temp }, () => {
    if (is_yes && temp.listener !== null) { temp.listener(); }
  });
}

export function showConfirmation(context) {
  if (context.state.confirmation_dialog === undefined) {
    context.state.confirmation_dialog = {
      show : false,
      title : 'Notice',
      message : 'Apakah anda setuju dengan aksi ini?',
      data : null,
      listener : null
    }
  }
  if (context.state.confirmation_dialog.show) {
    return (
      <div style={m_style.root_dialog} >
        <div style={m_style.dialog_container}>
          <div style={{flex : 1, display : 'flex', flexDirection : 'column', padding : 20}}>
            <div className='crs_default fnt_blk_a txt_12 txt_bold'><span>{context.state.confirmation_dialog.title}</span></div>
            <div className='crs_default fnt_blk_a txt_12' style={{padding : '20px 0'}}><span>{context.state.confirmation_dialog.message}</span></div>
            <div style={{display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
              { getButton({text : 'Tidak', text_class : 'fnt_blk_a txt_14', inner_style : {width : 60}}, () => closeConfirmation(context, false)) }
              { getButton({text : 'Ya', text_class : 'fnt_ntv_a txt_14', inner_style : {width : 60}}, () => closeConfirmation(context, true)) }
            </div>
          </div>
        </div>
      </div>
    );
  } else { return null; }
}

const m_style = {
  root_dialog : {
    display : 'flex',
    flexDirection : 'column',
    position : 'fixed',
    overflow : 'auto',
    zIndex : 4,
    top : 0, left : 0,
    width : '100%',
    height : '100%',
    backgroundColor : 'rgba(0, 0, 0, 0.5)'
  },
  dialog_container : {
    display : 'flex',
    flexDirection : 'column',
    width : '80%',
    maxWidth : 400,
    backgroundColor : 'white',
    borderRadius : 10,
    margin : 'auto'
  }
}
